import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { SecondaryBody } from '@grnhse/seedling/lib/birch/typography';
import { formatShortDate } from 'talent_search/lib/utils';
import { useRediscoveryApplication } from 'talent_matching/talent_rediscovery/hooks/use_rediscovery_applications';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix(
  'talent_matching.rediscovery.table.application_history'
);

type LatestApplicationHistoryCellProps = {
  applicationId: number;
  userDateFormat?: string;
};

const LatestApplicationHistoryCell = ({
  applicationId,
  userDateFormat = 'month_day_year',
}: LatestApplicationHistoryCellProps) => {
  const { application } = useRediscoveryApplication(applicationId);

  if (!application) {
    return null;
  }

  return (
    <Stack
      spacing={0.5}
      alignContent="flex-start"
      sx={{
        padding: 1,
        paddingLeft: 0,
        height: '100%',
      }}
    >
      <SecondaryBody medium>{application.hiringPlanName}</SecondaryBody>
      {application.appliedOn && (
        <SecondaryBody metadata>
          {t('applied_on', {
            date: formatShortDate(application.appliedOn, userDateFormat),
          })}
        </SecondaryBody>
      )}
      {application.rejectedOn && (
        <SecondaryBody metadata>
          {t('rejected_on', {
            date: formatShortDate(application.rejectedOn, userDateFormat),
          })}
        </SecondaryBody>
      )}
    </Stack>
  );
};

export default LatestApplicationHistoryCell;
